import { render, staticRenderFns } from "./Role.vue?vue&type=template&id=50a8b0d9"
import script from "./Role.vue?vue&type=script&lang=js"
export * from "./Role.vue?vue&type=script&lang=js"
import style0 from "./Role.vue?vue&type=style&index=0&id=50a8b0d9&prod&lang=scss"
import style1 from "./Role.vue?vue&type=style&index=1&id=50a8b0d9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports